module.exports = __webpack_public_path__ + "img/file.545e21a3.svg";